<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TipsMessage',
  props: {
    labelId: {
      type: String,
      default: ''
    }
  },
  computed: {
     ...mapGetters({
      active: 'Interface/showTips',
    }),
    label() {
      return this.$t(`tips.${this.labelId}`);
    }
  },
}
</script>

<template>
  <div :class="['tips-message', {'-active': active}]">
    <div class='message' v-html='label' />
  </div>
</template>

<style scoped lang="scss">
.tips-message {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  z-index: $z-index-bubble + 10;
  background-color: rgba(0,37,42,0.5);
  opacity: 0;
  pointer-events:none;
  transition: all .5s ease-out;
  @include flexbox(center-vertical);

  @include landscape {
    display: none;
  }

  &.-active {
    opacity: 1;

    .message {
      transform: scale(1);
      opacity: 1;
    }
  }
  
  .message {
    color:$c-white;
    font-size:1.5em;
    opacity: 0;
    transform: scale(.5);
    transition: all .2s ease-out;
    transition-delay: 0.3s;
  }
}
</style>
